import { EVENTS_SYSTEM_NAME, USER_INTERACTION_EVENT } from "@zapier/utils";
import emitEvent from "./emitEvent";

export enum UserInteractionName {
  FolderAction = "folder_action",
  FolderSearchInteraction = "folder_search_interaction",
  ProjectAction = "project_action",
  SetDefaultView = "set_default_view",
  ShareUpsell = "share_upsell",
  ZapBulkAction = "zap_bulk_action",
  ZapKebab = "zap_kebab_interaction",
  ZapRowToggle = "zap_row_toggle_zap",
  ZapSearchInteraction = "zap_search_interaction",
  ZapsPageOptOut = "zaps_page_opt_out",
}

export interface EmitUserInteractionEvent {
  accountId?: number;
  customTrackingFields?: any;
  eventAction: "click";
  interactionGoal?: string;
  interactionName: UserInteractionName;
  interactionRawText?: string;
  optionSelected?: string;
  systemName?: string;
}

const emitUserInteractionEvent = ({
  accountId,
  customTrackingFields = {},
  eventAction,
  interactionGoal = "",
  interactionName,
  interactionRawText = "",
  optionSelected = "",
  systemName,
}: EmitUserInteractionEvent) =>
  emitEvent(USER_INTERACTION_EVENT, {
    account_id: accountId,
    custom_tracking_fields: customTrackingFields,
    event_action: eventAction,
    interaction_goal: interactionGoal,
    interaction_name: interactionName,
    interaction_raw_text: interactionRawText,
    option_selected: optionSelected,
    system_name: systemName || EVENTS_SYSTEM_NAME,
  });

export default emitUserInteractionEvent;
